<script setup lang="ts"> 
import type { ComponentExposed } from 'vue-component-type-helpers';
import { InputGenericSingleSelect } from '#components'; 
   
const modal = ref<ComponentExposed<typeof InputGenericSingleSelect<AppFitterCategoryDTO>> | null>(null);

const { t } = useEkI18n();
const { getFitterCategoriesForFitter } = useHourRegistrationAPI();
  
const settingsStore = useSettingsStore();
const userConfigStore = useUserConfigurationStore();
  
const fitterCategories = ref<AppFitterCategoryDTO[]>([]);

const selectedFitterCategory = ref<AppFitterCategoryDTO | null>(null);

function selectFitterCategory(fitterCategory: AppFitterCategoryDTO) {
  selectedFitterCategory.value = fitterCategory;

  settingsStore.set('defaultFitterCategoryID', fitterCategory.ID);
}

function clear() {
  selectedFitterCategory.value = null;
  settingsStore.set('defaultFitterCategoryID', null);
}

const label = computed(() => {
  if (selectedFitterCategory.value) {
    return selectedFitterCategory.value.Reference + ': ' + selectedFitterCategory.value.CategoryName;
 
  } else {
    return t('input.none');
  }
});

onMounted(async () => {
  const response = await getFitterCategoriesForFitter(userConfigStore.fitterId);

  if (response && response.HasErrors === false) {
    fitterCategories.value = response.Data.CategoriesSearchResponseDTOs;
  }  
 
  const fitterCategory = fitterCategories.value.find(fitterCategory => fitterCategory.ID === settingsStore.settings.defaultFitterCategoryID);

  if (fitterCategory) {
    selectedFitterCategory.value = fitterCategory;
  } else {
    selectedFitterCategory.value = null;
  }
});
  
</script>
  
<template>
  <IonItem
    lines="full"
    button
    @click="modal?.open()"
  >
    <IonLabel> 
      {{ t('settings.hourRegistration.fitterCategory.header') }}
       
      <p class="description">
        {{ t('settings.hourRegistration.fitterCategory.description') }}
      </p>

      <div class="justify">
        <p class="ellipsis">
          {{ label }}
        </p>
        <IonButton 
          slot="end"
          fill="clear"
          :style="selectedFitterCategory ? 'visibility: visible' : 'visibility: hidden'"
          @click.stop="clear"
        >
          {{ t('buttons.clear') }}
        </IonButton> 
      </div>
    </IonLabel>
  </IonItem>

  <InputGenericSingleSelect
    ref="modal"
    :items="fitterCategories"
    :title="t('input.selectFitterCategory')"
    :resolve-key="fitterCategory => fitterCategory.ID"
    :searchable-fields="['Reference', 'CategoryName', 'UnitName', 'WorkType']" 
    @select="selectFitterCategory"
  >
    <template #item="{ item }">
      {{ item.Reference }}: {{ item.CategoryName }}
    </template>
  </InputGenericSingleSelect> 
</template>
  
  <style scoped>
  .description { 
    color: var(--ion-color-medium);
    padding: 0.5rem 0;
  }
  
  .justify {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; 
    color: var(--ion-color-primary);
  }
  </style>
  